export default "__VITE_ASSET__ecESwaTl__"